// Bilingual content (Italian / English) for the Ing. Alessandro Perago website.

// Client / workplace logos (order matches the `clients.logos` arrays below).
export const CLIENT_LOGOS = [
  { src: "/logos/rina.svg", h: "h-8 lg:h-9" },
  { src: "/logos/marina.svg", h: "h-14 lg:h-16" },
  { src: "/logos/adp.svg", h: "h-9 lg:h-10" },
  { src: "/logos/mic.svg", h: "h-12 lg:h-14" },
  { src: "/logos/anac.png", h: "h-9 lg:h-10" },
  { src: "/logos/poliba.png", h: "h-12 lg:h-14" },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/20273065/pexels-photo-20273065.jpeg",
  blueprint: "/images/verifica.webp",
  about: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c",
  safety: "/images/sicurezza.webp",
  governance: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
  emf: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e",
  acoustics: "/images/acustica.webp",
  portfolio: [
    "https://images.unsplash.com/photo-1515674744565-0d7112cd179a",
    "https://images.unsplash.com/photo-1762088803377-09aade6ba7d3",
    "https://images.pexels.com/photos/1816030/pexels-photo-1816030.jpeg",
    "https://images.unsplash.com/photo-1527335988388-b40ee248d80c",
  ],
};

export const translations = {
  it: {
    nav: {
      about: "Chi sono",
      services: "Servizi",
      skills: "Competenze",
      portfolio: "Progetti",
      method: "Metodo",
      contact: "Contatti",
      cta: "Richiedi una consulenza",
    },
    hero: {
      overline: "Studio di Ingegneria — Bari",
      title: "Ing. Alessandro Perago",
      subtitle:
        "Soluzioni ingegneristiche innovative, progettazione tecnica e consulenza professionale.",
      text:
        "Un approccio fondato su competenza, precisione e attenzione al dettaglio per sviluppare soluzioni efficienti e sostenibili.",
      ctaPrimary: "Richiedi una consulenza",
      ctaSecondary: "Scopri i servizi",
      stat1: "Anni di esperienza",
      stat2: "Pubblicazioni tecniche",
      stat3: "Certificazioni & albi",
    },
    presentation: {
      overline: "Il metodo",
      title: "Professionalità, metodo e innovazione",
      text:
        "Ogni progetto nasce dall'incontro tra competenza tecnica, analisi approfondita e capacità di trovare soluzioni efficaci. L'attività dell'Ing. Alessandro Perago si basa su un metodo rigoroso orientato alla qualità, alla sicurezza e al raggiungimento degli obiettivi del cliente.",
      values: [
        {
          icon: "Cog",
          title: "Competenza tecnica",
          text:
            "Approccio specialistico e conoscenza approfondita delle metodologie progettuali.",
        },
        {
          icon: "ShieldCheck",
          title: "Affidabilità",
          text:
            "Precisione, rispetto delle tempistiche e attenzione alle esigenze del cliente.",
        },
        {
          icon: "Boxes",
          title: "Innovazione",
          text:
            "Utilizzo di strumenti moderni per ottimizzare progettazione e risultati.",
        },
      ],
    },
    about: {
      overline: "Chi sono",
      title: "Un percorso costruito sulla competenza",
      text:
        "L'Ing. Alessandro Perago sviluppa la propria attività attraverso un percorso professionale caratterizzato da formazione continua, aggiornamento tecnico e attenzione verso le nuove tecnologie applicate all'ingegneria.",
      timeline: [
        {
          year: "2000",
          title: "Laurea in Ingegneria Edile",
          place: "Politecnico di Bari — 110/110",
          text:
            "Indirizzo Progettazione Architettonica. Abilitazione all'esercizio della professione di Ingegnere e iscrizione all'Ordine degli Ingegneri di Bari (matr. 5961).",
        },
        {
          year: "2001 — 2008",
          title: "Dottorato di Ricerca e attività scientifica",
          place: "Università del Salento",
          text:
            "Dottore di Ricerca in Sistemi Energetici ed Ambiente. Assegno e borsa di studio in Fluidodinamica applicata all'ingegneria civile e industriale.",
        },
        {
          year: "2001 — 2007",
          title: "Pubblicazioni tecniche",
          place: "Riviste tecniche specializzate",
          text:
            "Autore di volumi tecnici e di oltre 60 articoli su riviste nazionali e internazionali di ingegneria, energia e sicurezza.",
        },
        {
          year: "2018 — 2019",
          title: "Certificazioni e incarichi istituzionali",
          place: "CERTing · ANAC · MISE · ENTECA",
          text:
            "Ingegnere Esperto in Sistemi Edilizi (CERTing), Innovation Manager (MISE), componente commissioni giudicatrici ANAC, Tecnico Competente in Acustica Ambientale.",
        },
        {
          year: "Oggi",
          title: "Verifica e ispezione della progettazione",
          place: "RINA Check S.r.l.",
          text:
            "Ispettore per la verifica preventiva della progettazione di opere complesse, con controllo di qualità, costi, acustica, sicurezza e cantierizzazione.",
        },
        {
          year: "Oggi",
          title: "Vice Responsabile Tecnico",
          place: "ASSET",
          text:
            "Coordinamento tecnico e supervisione delle attività di verifica e ispezione, a garanzia della qualità e della conformità dei progetti.",
        },
      ],
      credentialsTitle: "Abilitazioni & albi",
      credentials: [
        "Ordine degli Ingegneri di Bari — Sez. A",
        "Ingegnere Esperto Sistemi Edilizi (CERTing)",
        "Prevenzione Incendi (L. 818/84)",
        "RSPP & Coordinatore Sicurezza (D.Lgs. 81/08)",
        "Tecnico Competente Acustica Ambientale (ENTECA)",
        "Innovation Manager (MISE)",
        "Commissioni giudicatrici ANAC",
        "Perito & valutazione immobiliare",
        "AiFOS — RSPP · Attestato 606/26",
        "AiFOS — Consulente della Sicurezza · Attestato 41/26",
        "Consulente Tecnico di Ufficio e di Parte (CTU/CTP)",
      ],
    },
    services: {
      overline: "Servizi",
      title: "Un supporto completo per ogni fase del progetto",
      cta: "Approfondisci",
      items: [
        {
          icon: "SearchCheck",
          title: "Verifica progetti",
          text:
            "Verifica preventiva della progettazione, con controllo di costi, sicurezza e cantierizzazione.",
        },
        {
          icon: "Lightbulb",
          title: "Consulenza tecnica",
          text:
            "Supporto professionale per analisi, valutazioni e ottimizzazione dei processi progettuali.",
        },
        {
          icon: "Activity",
          title: "Attività strumentali",
          text:
            "Misure strumentali di campi elettromagnetici e di acustica ambientale per verifiche di conformità e monitoraggio.",
        },
        {
          icon: "ShieldCheck",
          title: "Sicurezza e salute negli ambienti di lavoro",
          text:
            "Valutazione dei rischi, prevenzione e protezione e ruolo di RSPP per ambienti di lavoro sicuri e conformi.",
        },
        {
          icon: "ClipboardCheck",
          title: "Gestione e organizzazione dei modelli ex D.Lgs 231 (MOG)",
          text:
            "Progettazione, implementazione e aggiornamento dei Modelli di Organizzazione, Gestione e Controllo ex D.Lgs 231/2001, nonché ruolo di organismo di vigilanza.",
        },
        {
          icon: "GraduationCap",
          title: "Formazione qualità, sicurezza e ambiente",
          text:
            "Attività formativa specialistica su qualità, sicurezza sul lavoro e tematiche ambientali.",
        },
      ],
    },
    skills: {
      overline: "Competenze tecniche",
      title: "Conoscenze specialistiche e strumenti professionali",
      groups: [
        {
          title: "Progettazione",
          items: ["Progettazione edile", "Architettura", "Involucro edilizio", "Coperture & tetti"],
        },
        {
          title: "Analisi tecnica",
          items: ["Fluidodinamica (CFD)", "Termotecnica", "Acustica ambientale", "Analisi energetica"],
        },
        {
          title: "Software professionali",
          items: ["CAD", "Modellazione 3D / BIM", "Software di calcolo", "Analisi numerica"],
        },
        {
          title: "Normative",
          items: ["Prevenzione incendi", "Sicurezza D.Lgs. 81/08", "Antisismica", "Codice appalti"],
        },
        {
          title: "Gestione progetto",
          items: ["Verifica progettazione", "Stima dei costi", "Direzione lavori", "Coordinamento"],
        },
        {
          title: "Problem solving",
          items: ["Ottimizzazione", "Efficienza energetica", "Sostenibilità", "Innovation management"],
        },
      ],
    },
    portfolio: {
      overline: "Progetti & incarichi",
      title: "Aree di attività",
      note:
        "Cinque ambiti principali di intervento. Seleziona un'area per approfondire.",
      topics: [
        {
          id: "verifica",
          title: "Verifica della progettazione",
          text:
            "Attività di ispezione e verifica preventiva della progettazione ai fini della validazione, per opere complesse pubbliche e private. Controllo di completezza, qualità, costi, sicurezza e cantierizzazione, in collaborazione con organismi di ispezione accreditati.",
          image: IMAGES.blueprint,
          partnersLabel: "Committenti e collaborazioni",
          partners: [
            { name: "RINA Check", src: "/logos/rina.svg" },
            { name: "ASSET (CAB)", src: "/logos/asset.png" },
            { name: "Bureau Veritas", src: "/logos/bureauveritas.png" },
          ],
        },
        {
          id: "sicurezza",
          title: "Sicurezza e salute negli ambienti di lavoro",
          text:
            "Ruolo di Responsabile del Servizio di Prevenzione e Protezione (RSPP): valutazione dei rischi, sistemi di gestione della sicurezza, formazione e supporto continuo alle aziende per la piena conformità al D.Lgs 81/2008.",
          image: IMAGES.safety,
          partnersLabel: "Committenti e collaborazioni",
          partners: [
            { name: "Arrigoni", src: "/logos/arrigoni.png" },
            { name: "Ecoeridania", src: "/logos/ecoeridania.png" },
            { name: "Blulogis", src: "/logos/blulogis.png" },
            { name: "Kimya S.r.l.", src: "/logos/kimya.jpeg" },
            { name: "Semolificio Loiudice", src: "/logos/loiudice.png" },
            { name: "Socoges", src: "/logos/socoges.jpeg" },
            { name: "CAMA Ricambi Auto", src: "/logos/cama.png" },
            { name: "Diesel Levante", src: "/logos/diesellevante.jpg" },
            { name: "Trasporti Ferroviari Italiani", src: "/logos/tfi.jpeg" },
            { name: "Ariete Servizi Integrati", src: "/logos/ariete.webp" },
            { name: "Guastamacchia", src: "/logos/guastamacchia.webp" },
            { name: "Consoff", src: "/logos/consoff.webp" },
            { name: "Trasporti Autobus Italiani", src: "/logos/trasportiautobus.webp" },
            { name: "L'Obiettivo Cooperativa Sociale", src: "/logos/lobiettivo.jpeg" },
            { name: "MEIT Multiservices", src: "/logos/meit.png" },
            { name: "Navita", src: "/logos/navita.jpeg" },
          ],
        },
        {
          id: "odv231",
          title: "Organismo di Vigilanza ex D.Lgs 231",
          text:
            "Componente di Organismi di Vigilanza ai sensi del D.Lgs 231/2001, quale esperto in materia ambientale e di sicurezza sul lavoro. Vigilanza sull'adeguatezza e sull'aggiornamento dei Modelli di Organizzazione, Gestione e Controllo.",
          image: IMAGES.governance,
          partnersLabel: "Committenti e collaborazioni",
          partners: [
            { name: "Eco Sud Ricicli S.r.l.", src: "/logos/ecosud.png" },
            { name: "Dupont Energetica S.r.l.", src: "/logos/dupont.jpeg" },
            { name: "Consorzio A.S.I. Bari", src: "/logos/consorzioasi.jpeg" },
            { name: "Debar Costruzioni S.p.A.", src: "/logos/debar.png" },
            { name: "AC Servizi e Trasporti", src: "/logos/acservizi.png" },
            { name: "Casillo Group", src: "/logos/casillonew.png" },
            { name: "Aleandri S.p.A.", src: "/logos/aleandri.png" },
            { name: "DMF Costruzioni S.r.l.", src: "/logos/dmf.webp" },
            { name: "Takler", src: "/logos/takler.jpg" },
            { name: "Lokhen", src: "/logos/lokhen.png" },
            { name: "Faver S.p.A.", src: "/logos/faver.jpeg" },
            { name: "MetalBa", src: "/logos/metalba.webp" },
            { name: "Sanitaservice ASL BAT", src: "/logos/sanitaservice.png" },
            { name: "Edil Tecno", src: "/logos/ediltecno.jpg" },
            { name: "Master Italy", src: "/logos/masteritaly.jpg" },
            { name: "Autocar Tecnologie", src: "/logos/autocar.jpeg" },
          ],
        },
        {
          id: "emf",
          title: "Misura dei campi elettromagnetici",
          text:
            "Rilievi e misurazioni dei campi elettromagnetici in prossimità di elettrodotti e di impianti di telefonia, oltre alla verifica dei varchi antitaccheggio nei punti vendita, per garantire la conformità ai limiti di legge e la tutela della salute.",
          image: IMAGES.emf,
          partnersLabel: "Committenti e collaborazioni",
          partners: [
            { name: "TIM", src: "/logos/tim.svg" },
            { name: "Vodafone", src: "/logos/vodafone.svg" },
            { name: "Wind Tre", src: "/logos/windtre.svg" },
            { name: "Zara", src: "/logos/zara.svg" },
            { name: "Bershka", src: "/logos/bershka.svg" },
            { name: "Stradivarius", src: "/logos/stradivarius.svg" },
            { name: "Pull&Bear", src: "/logos/pullbear.svg" },
            { name: "Oysho", src: "/logos/oysho.svg" },
            { name: "Sephora", src: "/logos/sephora.svg" },
            { name: "OVS", src: "/logos/ovs.png" },
            { name: "Unieuro", src: "/logos/unieuro.webp" },
          ],
        },
        {
          id: "acustica",
          title: "Impatto acustico e requisiti acustici passivi",
          text:
            "Valutazioni di impatto acustico ambientale e verifica dei requisiti acustici passivi degli edifici. L'attività comprende rilievi fonometrici in campo, previsioni di clima e impatto acustico, redazione della documentazione tecnica e individuazione di soluzioni di mitigazione e isolamento, per garantire il comfort abitativo e il pieno rispetto dei limiti fissati dalla normativa vigente.",
          image: IMAGES.acoustics,
          partnersLabel: "Committenti e collaborazioni",
          partners: [],
        },
      ],
    },
    method: {
      overline: "Metodo di lavoro",
      title: "Un processo chiaro, dalla progettazione alla realizzazione",
      steps: [
        { num: "01", title: "Analisi", text: "Studio delle esigenze e degli obiettivi." },
        { num: "02", title: "Progettazione", text: "Sviluppo della soluzione tecnica." },
        { num: "03", title: "Ottimizzazione", text: "Controllo qualità e miglioramento." },
        { num: "04", title: "Realizzazione", text: "Supporto fino alla conclusione del progetto." },
      ],
    },
    clients: {
      overline: "Committenti & collaborazioni",
      title: "Al fianco di enti e realtà di primo piano",
      logos: [
        { name: "RINA Check", sub: "Verifica progettazione" },
        { name: "Marina Militare", sub: "Programma Basi Blu" },
        { name: "Aeroporti di Puglia", sub: "Aeroporto di Bari" },
        { name: "Reggia di Caserta", sub: "Ministero della Cultura" },
        { name: "ANAC", sub: "Commissioni giudicatrici" },
        { name: "Politecnico di Bari", sub: "Formazione & ricerca" },
      ],
    },
    contact: {
      overline: "Contatti",
      title: "Costruiamo insieme il prossimo progetto",
      text:
        "Descrivi la tua esigenza: riceverai una risposta professionale e senza impegno.",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono",
        message: "Messaggio",
        submit: "Invia richiesta",
        sending: "Invio in corso…",
        success: "Richiesta inviata correttamente. Ti risponderò al più presto.",
        error: "Si è verificato un errore. Riprova o contattami direttamente.",
      },
      infoTitle: "Recapiti",
      email: "alessandro.perago@gmail.com",
      pec: "alessandro.perago@ingpec.eu",
      phone: "+39 349 296 5933",
      address: "Via Gaetano Salvemini 68 — Bari",
      vat: "P.IVA 06183700720",
    },
    footer: {
      tagline:
        "Competenza ingegneristica, precisione progettuale e affidabilità professionale.",
      rights: "Tutti i diritti riservati.",
      built: "Progettazione e consulenza ingegneristica — Bari",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      notes: "Note legali",
    },
    cookie: {
      message:
        "Questo sito utilizza esclusivamente cookie tecnici necessari al suo funzionamento e alla memorizzazione della lingua. Non vengono utilizzati cookie di profilazione. Continuando la navigazione acconsenti al loro utilizzo.",
      accept: "Accetta",
      reject: "Solo necessari",
      more: "Maggiori informazioni",
    },
    legal: {
      close: "Chiudi",
      updated: "Ultimo aggiornamento: dicembre 2025",
      notes: {
        title: "Note legali",
        body: [
          { h: "Copyright", p: "Tutti i contenuti del sito — testi, immagini, grafiche e materiali — sono tutelati dalle vigenti norme sul diritto d'autore. È vietata la riproduzione, anche parziale, con qualsiasi mezzo, senza autorizzazione scritta." },
          { h: "Marchi e loghi", p: "I marchi e i loghi delle aziende e degli enti riportati appartengono ai rispettivi proprietari e sono utilizzati esclusivamente a scopo illustrativo, per rappresentare committenti e collaborazioni professionali." },
          { h: "Disclaimer sui contenuti", p: "Le informazioni pubblicate hanno finalità puramente informative e non costituiscono consulenza professionale vincolante. Pur garantendo la massima cura, non si assumono responsabilità per eventuali errori, omissioni o per l'uso che ne venga fatto da parte dell'utente." },
          { h: "Collegamenti esterni", p: "Il sito può contenere collegamenti a risorse esterne dei cui contenuti non si ha il controllo: non si risponde della loro disponibilità, correttezza o completezza." },
        ],
      },
      privacy: {
        title: "Privacy Policy",
        body: [
          { h: "Titolare del trattamento", p: "Ing. Alessandro Perago — Bari (Italia). PEC: alessandro.perago@ingpec.eu." },
          { h: "Dati raccolti", p: "Attraverso il modulo di contatto vengono raccolti i dati che l'utente fornisce volontariamente: nome, email, eventuale telefono e messaggio. Non vengono raccolti dati particolari." },
          { h: "Finalità", p: "I dati sono trattati unicamente per rispondere alle richieste di contatto e consulenza e non vengono comunicati a terzi né utilizzati per finalità di marketing." },
          { h: "Base giuridica e conservazione", p: "Il trattamento si fonda sul consenso dell'interessato. I dati sono conservati per il tempo necessario a gestire la richiesta e adempiere agli obblighi di legge." },
          { h: "Diritti dell'interessato", p: "L'utente può in ogni momento richiedere accesso, rettifica, cancellazione o limitazione dei propri dati, scrivendo alla PEC del Titolare, ai sensi del Regolamento (UE) 2016/679 (GDPR)." },
        ],
      },
      cookies: {
        title: "Cookie Policy",
        body: [
          { h: "Cosa sono i cookie", p: "I cookie sono piccoli file memorizzati dal browser per consentire il corretto funzionamento del sito." },
          { h: "Cookie utilizzati", p: "Questo sito utilizza esclusivamente cookie/archiviazione tecnici e funzionali (ad esempio la preferenza di lingua). Non sono presenti cookie di profilazione, analitici o di terze parti." },
          { h: "Gestione dei cookie", p: "È possibile eliminare o bloccare i cookie tecnici tramite le impostazioni del proprio browser; ciò potrebbe limitare alcune funzionalità del sito." },
        ],
      },
    },
  },

  en: {
    nav: {
      about: "About",
      services: "Services",
      skills: "Expertise",
      portfolio: "Projects",
      method: "Method",
      contact: "Contact",
      cta: "Request a consultation",
    },
    hero: {
      overline: "Engineering Practice — Bari, Italy",
      title: "Ing. Alessandro Perago",
      subtitle:
        "Innovative engineering solutions, technical design and professional consultancy.",
      text:
        "An approach grounded in expertise, precision and attention to detail to deliver efficient and sustainable solutions.",
      ctaPrimary: "Request a consultation",
      ctaSecondary: "Explore services",
      stat1: "Years of experience",
      stat2: "Technical publications",
      stat3: "Certifications & registers",
    },
    presentation: {
      overline: "The method",
      title: "Professionalism, method and innovation",
      text:
        "Every project stems from the meeting of technical expertise, in-depth analysis and the ability to find effective solutions. Ing. Alessandro Perago's work is built on a rigorous method focused on quality, safety and achieving the client's objectives.",
      values: [
        {
          icon: "Cog",
          title: "Technical expertise",
          text:
            "A specialist approach and deep knowledge of design methodologies.",
        },
        {
          icon: "ShieldCheck",
          title: "Reliability",
          text:
            "Precision, respect for deadlines and attention to the client's needs.",
        },
        {
          icon: "Boxes",
          title: "Innovation",
          text:
            "Use of modern tools to optimise design and results.",
        },
      ],
    },
    about: {
      overline: "About",
      title: "A career built on expertise",
      text:
        "Ing. Alessandro Perago develops his practice through a professional path defined by continuous training, technical updating and a focus on new technologies applied to engineering.",
      timeline: [
        {
          year: "2000",
          title: "Degree in Building Engineering",
          place: "Polytechnic of Bari — 110/110",
          text:
            "Architectural Design specialisation. Professional qualification as Engineer and registration with the Order of Engineers of Bari (no. 5961).",
        },
        {
          year: "2001 — 2008",
          title: "PhD and scientific activity",
          place: "University of Salento",
          text:
            "PhD in Energy Systems and Environment. Research grant and scholarship in Fluid Dynamics applied to civil and industrial engineering.",
        },
        {
          year: "2001 — 2007",
          title: "Technical publications",
          place: "Specialist technical journals",
          text:
            "Author of technical volumes and over 60 articles in national and international journals of engineering, energy and safety.",
        },
        {
          year: "2018 — 2019",
          title: "Certifications & institutional roles",
          place: "CERTing · ANAC · MISE · ENTECA",
          text:
            "Certified Expert Engineer in Building Systems (CERTing), Innovation Manager (MISE), member of ANAC selection boards, Qualified Environmental Acoustics Technician.",
        },
        {
          year: "Today",
          title: "Design verification & inspection",
          place: "RINA Check S.r.l.",
          text:
            "Inspector for the prior verification of the design of complex works, with control of quality, costs, acoustics, safety and site planning.",
        },
        {
          year: "Today",
          title: "Deputy Technical Manager",
          place: "ASSET",
          text:
            "Technical coordination and supervision of verification and inspection activities, ensuring project quality and compliance.",
        },
      ],
      credentialsTitle: "Qualifications & registers",
      credentials: [
        "Order of Engineers of Bari — Sec. A",
        "Expert Engineer in Building Systems (CERTing)",
        "Fire Prevention (Law 818/84)",
        "Safety Manager & Coordinator (D.Lgs. 81/08)",
        "Qualified Environmental Acoustics Technician (ENTECA)",
        "Innovation Manager (MISE)",
        "ANAC selection boards",
        "Expert & real-estate valuation",
        "AiFOS — RSPP · Cert. 606/26",
        "AiFOS — Safety Consultant · Cert. 41/26",
        "Court-Appointed & Party Technical Consultant (CTU/CTP)",
      ],
    },
    services: {
      overline: "Services",
      title: "Complete support for every stage of the project",
      cta: "Learn more",
      items: [
        {
          icon: "SearchCheck",
          title: "Design verification",
          text:
            "Prior verification of the design, with control of costs, safety and site planning.",
        },
        {
          icon: "Lightbulb",
          title: "Technical consultancy",
          text:
            "Professional support for analysis, assessment and optimisation of design processes.",
        },
        {
          icon: "Activity",
          title: "Instrumental measurements",
          text:
            "Instrumental measurements of electromagnetic fields and environmental acoustics for compliance checks and monitoring.",
        },
        {
          icon: "ShieldCheck",
          title: "Occupational health & safety",
          text:
            "Risk assessment, prevention and protection and the RSPP role for safe, compliant workplaces.",
        },
        {
          icon: "ClipboardCheck",
          title: "Organisational models under Legislative Decree 231 (MOG)",
          text:
            "Design, implementation and updating of Organisation, Management and Control Models pursuant to Legislative Decree 231/2001, as well as the role of supervisory body.",
        },
        {
          icon: "GraduationCap",
          title: "Quality, safety & environment training",
          text:
            "Specialist training on quality, workplace safety and environmental matters.",
        },
      ],
    },
    skills: {
      overline: "Technical expertise",
      title: "Specialist knowledge and professional tools",
      groups: [
        {
          title: "Design",
          items: ["Building design", "Architecture", "Building envelope", "Roofing"],
        },
        {
          title: "Technical analysis",
          items: ["Fluid dynamics (CFD)", "Thermotechnics", "Environmental acoustics", "Energy analysis"],
        },
        {
          title: "Professional software",
          items: ["CAD", "3D modelling / BIM", "Calculation software", "Numerical analysis"],
        },
        {
          title: "Regulations",
          items: ["Fire prevention", "Safety D.Lgs. 81/08", "Seismic codes", "Public procurement"],
        },
        {
          title: "Project management",
          items: ["Design verification", "Cost estimation", "Works direction", "Coordination"],
        },
        {
          title: "Problem solving",
          items: ["Optimisation", "Energy efficiency", "Sustainability", "Innovation management"],
        },
      ],
    },
    portfolio: {
      overline: "Projects & assignments",
      title: "Areas of activity",
      note: "Five main areas of expertise. Select an area to learn more.",
      topics: [
        {
          id: "verifica",
          title: "Design verification",
          text:
            "Inspection and prior verification of the design for validation, for complex public and private works. Control of completeness, quality, costs, safety and site planning, in collaboration with accredited inspection bodies.",
          image: IMAGES.blueprint,
          partnersLabel: "Clients & collaborations",
          partners: [
            { name: "RINA Check", src: "/logos/rina.svg" },
            { name: "ASSET (CAB)", src: "/logos/asset.png" },
            { name: "Bureau Veritas", src: "/logos/bureauveritas.png" },
          ],
        },
        {
          id: "sicurezza",
          title: "Occupational health & safety",
          text:
            "Role of Prevention and Protection Service Manager (RSPP): risk assessment, safety management systems, training and ongoing support to companies for full compliance with Legislative Decree 81/2008.",
          image: IMAGES.safety,
          partnersLabel: "Clients & collaborations",
          partners: [
            { name: "Arrigoni", src: "/logos/arrigoni.png" },
            { name: "Ecoeridania", src: "/logos/ecoeridania.png" },
            { name: "Blulogis", src: "/logos/blulogis.png" },
            { name: "Kimya S.r.l.", src: "/logos/kimya.jpeg" },
            { name: "Semolificio Loiudice", src: "/logos/loiudice.png" },
            { name: "Socoges", src: "/logos/socoges.jpeg" },
            { name: "CAMA Ricambi Auto", src: "/logos/cama.png" },
            { name: "Diesel Levante", src: "/logos/diesellevante.jpg" },
            { name: "Trasporti Ferroviari Italiani", src: "/logos/tfi.jpeg" },
            { name: "Ariete Servizi Integrati", src: "/logos/ariete.webp" },
            { name: "Guastamacchia", src: "/logos/guastamacchia.webp" },
            { name: "Consoff", src: "/logos/consoff.webp" },
            { name: "Trasporti Autobus Italiani", src: "/logos/trasportiautobus.webp" },
            { name: "L'Obiettivo Cooperativa Sociale", src: "/logos/lobiettivo.jpeg" },
            { name: "MEIT Multiservices", src: "/logos/meit.png" },
            { name: "Navita", src: "/logos/navita.jpeg" },
          ],
        },
        {
          id: "odv231",
          title: "Supervisory Body under Legislative Decree 231",
          text:
            "Member of Supervisory Bodies pursuant to Legislative Decree 231/2001, as an expert in environmental and workplace safety matters. Oversight of the adequacy and updating of Organisation, Management and Control Models.",
          image: IMAGES.governance,
          partnersLabel: "Clients & collaborations",
          partners: [
            { name: "Eco Sud Ricicli S.r.l.", src: "/logos/ecosud.png" },
            { name: "Dupont Energetica S.r.l.", src: "/logos/dupont.jpeg" },
            { name: "Consorzio A.S.I. Bari", src: "/logos/consorzioasi.jpeg" },
            { name: "Debar Costruzioni S.p.A.", src: "/logos/debar.png" },
            { name: "AC Servizi e Trasporti", src: "/logos/acservizi.png" },
            { name: "Casillo Group", src: "/logos/casillonew.png" },
            { name: "Aleandri S.p.A.", src: "/logos/aleandri.png" },
            { name: "DMF Costruzioni S.r.l.", src: "/logos/dmf.webp" },
            { name: "Takler", src: "/logos/takler.jpg" },
            { name: "Lokhen", src: "/logos/lokhen.png" },
            { name: "Faver S.p.A.", src: "/logos/faver.jpeg" },
            { name: "MetalBa", src: "/logos/metalba.webp" },
            { name: "Sanitaservice ASL BAT", src: "/logos/sanitaservice.png" },
            { name: "Edil Tecno", src: "/logos/ediltecno.jpg" },
            { name: "Master Italy", src: "/logos/masteritaly.jpg" },
            { name: "Autocar Tecnologie", src: "/logos/autocar.jpeg" },
          ],
        },
        {
          id: "emf",
          title: "Electromagnetic field measurements",
          text:
            "Surveys and measurements of electromagnetic fields near power lines and telecommunication facilities, as well as checks on anti-theft gates in stores, to ensure compliance with legal limits and protection of health.",
          image: IMAGES.emf,
          partnersLabel: "Clients & collaborations",
          partners: [
            { name: "TIM", src: "/logos/tim.svg" },
            { name: "Vodafone", src: "/logos/vodafone.svg" },
            { name: "Wind Tre", src: "/logos/windtre.svg" },
            { name: "Zara", src: "/logos/zara.svg" },
            { name: "Bershka", src: "/logos/bershka.svg" },
            { name: "Stradivarius", src: "/logos/stradivarius.svg" },
            { name: "Pull&Bear", src: "/logos/pullbear.svg" },
            { name: "Oysho", src: "/logos/oysho.svg" },
            { name: "Sephora", src: "/logos/sephora.svg" },
            { name: "OVS", src: "/logos/ovs.png" },
            { name: "Unieuro", src: "/logos/unieuro.webp" },
          ],
        },
        {
          id: "acustica",
          title: "Acoustic impact & passive acoustic requirements",
          text:
            "Environmental acoustic impact assessments and verification of the passive acoustic requirements of buildings. The activity includes on-site sound-level surveys, acoustic climate and impact forecasts, preparation of technical documentation and identification of mitigation and insulation solutions, to ensure living comfort and full compliance with the limits set by current regulations.",
          image: IMAGES.acoustics,
          partnersLabel: "Clients & collaborations",
          partners: [],
        },
      ],
    },
    method: {
      overline: "Working method",
      title: "A clear process, from design to delivery",
      steps: [
        { num: "01", title: "Analysis", text: "Study of needs and objectives." },
        { num: "02", title: "Design", text: "Development of the technical solution." },
        { num: "03", title: "Optimisation", text: "Quality control and improvement." },
        { num: "04", title: "Delivery", text: "Support through to project completion." },
      ],
    },
    clients: {
      overline: "Clients & collaborations",
      title: "Alongside leading institutions and organisations",
      logos: [
        { name: "RINA Check", sub: "Design verification" },
        { name: "Italian Navy", sub: "Basi Blu Programme" },
        { name: "Aeroporti di Puglia", sub: "Bari Airport" },
        { name: "Palace of Caserta", sub: "Ministry of Culture" },
        { name: "ANAC", sub: "Selection boards" },
        { name: "Polytechnic of Bari", sub: "Training & research" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's build the next project together",
      text:
        "Describe your needs: you will receive a professional reply with no obligation.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        submit: "Send request",
        sending: "Sending…",
        success: "Request sent successfully. I will reply as soon as possible.",
        error: "An error occurred. Please try again or contact me directly.",
      },
      infoTitle: "Contact details",
      email: "alessandro.perago@gmail.com",
      pec: "alessandro.perago@ingpec.eu",
      phone: "+39 349 296 5933",
      address: "Via Gaetano Salvemini 68 — Bari, Italy",
      vat: "VAT 06183700720",
    },
    footer: {
      tagline:
        "Engineering expertise, design precision and professional reliability.",
      rights: "All rights reserved.",
      built: "Engineering design & consultancy — Bari, Italy",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      notes: "Legal notice",
    },
    cookie: {
      message:
        "This website uses only technical cookies necessary for its operation and to store the language preference. No profiling cookies are used. By continuing to browse you consent to their use.",
      accept: "Accept",
      reject: "Necessary only",
      more: "More information",
    },
    legal: {
      close: "Close",
      updated: "Last updated: December 2025",
      notes: {
        title: "Legal notice",
        body: [
          { h: "Copyright", p: "All website content — texts, images, graphics and materials — is protected by applicable copyright law. Reproduction, in whole or in part and by any means, is prohibited without written authorisation." },
          { h: "Trademarks & logos", p: "The trademarks and logos of the companies and institutions shown belong to their respective owners and are used for illustrative purposes only, to represent professional clients and collaborations." },
          { h: "Content disclaimer", p: "The information published is for informational purposes only and does not constitute binding professional advice. While the utmost care is taken, no liability is assumed for any errors, omissions or for the use made of it by the user." },
          { h: "External links", p: "The website may contain links to external resources whose content is not under our control: we are not responsible for their availability, accuracy or completeness." },
        ],
      },
      privacy: {
        title: "Privacy Policy",
        body: [
          { h: "Data controller", p: "Ing. Alessandro Perago — Bari (Italy). PEC: alessandro.perago@ingpec.eu." },
          { h: "Data collected", p: "Through the contact form we collect the data you voluntarily provide: name, email, optional phone and message. No special categories of data are collected." },
          { h: "Purpose", p: "Data is processed solely to respond to contact and consultancy requests and is not shared with third parties nor used for marketing." },
          { h: "Legal basis and retention", p: "Processing is based on the data subject's consent. Data is kept for as long as necessary to handle the request and comply with legal obligations." },
          { h: "Your rights", p: "You may at any time request access, rectification, erasure or restriction of your data by writing to the controller's PEC, pursuant to Regulation (EU) 2016/679 (GDPR)." },
        ],
      },
      cookies: {
        title: "Cookie Policy",
        body: [
          { h: "What cookies are", p: "Cookies are small files stored by the browser to allow the website to function correctly." },
          { h: "Cookies used", p: "This website uses only technical and functional cookies/storage (e.g. the language preference). There are no profiling, analytics or third-party cookies." },
          { h: "Managing cookies", p: "You can delete or block technical cookies via your browser settings; this may limit some website features." },
        ],
      },
    },
  },
};
